import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import Gem from "./Gem";
import {set} from "mobx";

function SubmitGem(props) {
    const {store, index, color, gem} = props;
    const circleSize = 40;

    let width = props.width / 2 + 100;
    const [gemPosition, setGemPosition] = useState({x: width - circleSize / 2, y: 4 + circleSize / 2});
    const requestRef = React.useRef();
    const velocityRef = React.useRef();
    const lastWidth = React.useRef();
    if (velocityRef.current === undefined) {
        velocityRef.current = 0;
    }
    if (velocityRef.current === 0 && width !== lastWidth.current) {//pre-animation, make sure this is responsive
        setGemPosition(prevVal => {
            return {
                x: width - circleSize / 2  - 5,
                y: prevVal.y
            }
        });
    }
    lastWidth.current = width;

    const frame = () => {
        velocityRef.current *= 1.1;
        let xVal;
        setGemPosition(prevVal => {
            xVal = prevVal.x + velocityRef.current;
            return {
                x: xVal,
                y: prevVal.y
            }
        });
        return xVal > 0;
    };

    const animate = () => {
        if (!frame()) {
            store.selectIndex(index, true);
            return;
        }
        requestRef.current = requestAnimationFrame(animate);
    };

    const animateGem = () => {
        velocityRef.current = -15;
        requestRef.current = requestAnimationFrame(animate);
    };

    if (index > 100 || !gem) {//bit of a hack for submits that don't complete the section
        return (
            <div className={'SubmitGem'}>
                <button className="submit" onClick=
                    {() => {
                        store.selectIndex(index, true);
                        store.getFbModel().saveOrUpdate();
                    }}>Submit
                </button>
            </div>
        );
    }

    return (
        <div className={'SubmitGem'}>
            <svg width={width} height={circleSize}>
                <Gem
                    cx={gemPosition.x}
                    cy={gemPosition.y}
                    fill={color}
                    stroke={color}
                    progress={Number.MAX_VALUE}
                    activated={true}
                    clickable={false}
                    r={circleSize / 2 - 1}
                />
            </svg>
            <button className="submit" onClick=
                {() => {
                    animateGem();
                    store.getFbModel().saveOrUpdate();

                }}>Submit
            </button>
        </div>
    );
}

export default observer(SubmitGem);
